import { makeStyles } from '@mui/styles';

export const useStyle = makeStyles((theme) => ({
  root: {},

  input: {},

  inputLabel: {},

  inputHelperText: {},

  adornment: {
    margin: 0,
    height: '100%',
    cursor: 'pointer'
  },

  icon: {
    fill: theme.palette.primary.main
  },

  iconCopied: {
    fill: theme.palette.secondary.main
  }
}));
